module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"description":"Enter your phone number to receive a link to the app store.","platforms":"Available on {iOS} and {android}","android":"Android","iOS":"iOS","backToSelect":"Back to import options","appStoreButtonText":"Go to the App Store"}}')
  delete Component.options._Ctor
}
